import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

import { Can } from '../../../_contexts/AbilitiesContext'

export default function TelehealthsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Telehealth Appointments To Display.
        </h5>
        <div className='my-4'>
          When you have Telehealth appointments scheduled they will appear here.
        </div>

        <Can I="schedule" a="telehealth">
          <Button as={Link} to='/telehealth/schedule' variant='outline-primary' className="px-5">
            Schedule Telehealth
          </Button>
        </Can>

      </Card.Body>
    </Card>
  )
}
